import { ShowCaseActionType } from "./enums/showCaseActionType";

/** Класс для данных о финпродукте */
export class ShowcaseFinProductData {

    /** Основное изображение */
    public imageMobile: string = "";

    /** Минимальное значение для слайдера. */
    public sliderMin: number = 0;

    /** Максимальное значение для слайдера. */
    public sliderMax: number = 0;

    /** Значение по умолчанию для слайдера. */
    public sliderDefault: number = 0;

    /** Шаг для слайдера. */
    public sliderStep: number = 0;

    /** Заголовок для слайдера суммы. */
    public sliderCaption: string = "";

    /** Знак валюты. */
    public currencySymbol: string = "";

    /** Текст с предупреждением. */
    public text: string = "";

    /** Тип действия элемента витрины. */
    public actionType: ShowCaseActionType = ShowCaseActionType.None;

    /** URL для действия элемента витрины. */
    public actionLink: string = "";

    /** Заголовок на кнопке основного действия */
    public actionCaption: string = "";

    /** Заголовок элемента приложений */
    public expandedBlockCaption: string = "";

    /** Наименование свойства, в которое будет помещена сумма, при открытии операции через кнопку основного действия */
    public sumPropertyName: string = "";

    /** Условия элемента витрины. */
    public conditions: Condition[] = [];

    /** Приложения элемента витрины. */
    public attachments: Attachment[] = [];

    constructor(finProductData: any) {
        this.imageMobile = finProductData.imageMobile ?? "";
        this.sliderMin = Number(finProductData.sliderMin) || 0;
        this.sliderMax = Number(finProductData.sliderMax) || 0;
        this.sliderDefault = Number(finProductData.sliderDefault) || 0;
        this.sliderStep = Number(finProductData.sliderStep) || 0;
        this.sliderCaption = finProductData.sliderCaption ?? "";
        this.currencySymbol = finProductData.currencySymbol ?? "";
        this.text = finProductData.text ?? "";
        this.actionType = (finProductData.actionType as ShowCaseActionType) ?? ShowCaseActionType.None;
        this.actionLink = finProductData.actionLink ?? "";
        this.actionCaption = finProductData.actionCaption ?? "";
        this.expandedBlockCaption = finProductData.expandedBlockCaption ?? "";
        this.sumPropertyName = finProductData.sumPropertyName ?? "";

        // Обработка условий
        if (Array.isArray(finProductData.conditions)) {
            this.conditions = finProductData.conditions.map((condition: any) => ({
                image: condition.image ?? "",
                caption: condition.caption ?? "",
                details: condition.details ?? "",
                actionType: condition.actionType ?? undefined,
                actionLink: condition.actionLink ?? undefined,
            }));
        }

        // Обработка приложений
        if (Array.isArray(finProductData.attachments)) {
            this.attachments = finProductData.attachments.map((attachment: any) => ({
                name: attachment.name ?? "",
                actionType: attachment.actionType ?? undefined,
                actionLink: attachment.actionLink ?? undefined,
            }));
        }
    }
}

interface Condition {
    image: string;
    caption: string;
    details: string;
    actionType?: string;
    actionLink?: string;
}

interface Attachment {
    name: string;
    actionType?: string;
    actionLink?: string;
}
